import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { adexStatistics } from 'lib/api/adex';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import MbSelectbox from 'components/molecules/MbSelectbox';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import StatisticsGraph from './StatisticsGraph';
import AdExStatisticsGraph from './AdExStatisticsGraph';
import AdExPrivateStatisticsGraph from './AdExPrivateStatisticsGraph';

let initialization = false;
// 공통 필터에서 초기값 받아왔는지 확인
let getInitParam = false;
const Statistics = () => {
  const adexIds = [
    { mediamixer: '미디어믹서(구글)' },
    { criteo: '크리테오' },
    { widerplanet: '와이더플래닛' },
    { iwmgg: '인터웍스_구글' },
    { dable1: '데이블' },
    { adop: '애드오피' },
    { toast: 'NHN ACE' },
    { adfit: '애드핏' },
    { adexinter: '인터웍스' },
    { manplus: '메조미디어' },
    { ekbeatle: '나스미디어' },
  ];
  const tableOptionList = [
    { CODE_ID: 0, CODE_DESC: i18next.t('지출금액') },
    { CODE_ID: 1, CODE_DESC: i18next.t('노출') },
    { CODE_ID: 2, CODE_DESC: i18next.t('CTR') },
    { CODE_ID: 3, CODE_DESC: i18next.t('ECPM') },
  ];

  const initParam = {
    type: 'advrtsAmt',
    ids: '',
  };

  initParam.ids += adexIds.map((item) => {
    return Object.keys(item)[0];
  });
  const { t } = useTranslation();

  const [params, setParams] = useState(initParam);
  const [tableOptionCode, setTableOptionCode] = useState(0);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  //   // header 및 body 컬럼 커스텀
  //   const customized = getAdexCustomData();
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');

        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );
        var dayOfWeek = new Date(dateValue).getDay();

        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = {
            color: 'red',
          };
        } else if (dayOfWeek === 6) {
          dayColor = {
            color: 'blue',
          };
        }

        return (
          <>
            <p style={dayColor}>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
            </p>
          </>
        );
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    getInitParam = true;
    setParams({
      ...params,
      ...newParams,
    });
  };

  const handleFilterChange = (name, index) => {
    let tempValue;
    if (index === 0) {
      tempValue = 'advrtsAmt';
    } else if (index === 1) {
      tempValue = 'parEprsCnt';
    } else if (index === 2) {
      tempValue = 'ctr';
    } else if (index === 3) {
      tempValue = 'ecpm';
    }
    setTableOptionCode(index);
    setParams({
      ...params,
      [name]: tempValue,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
        />
        <MbSelectbox
          label={t('타입')}
          value={tableOptionCode}
          itemindex={tableOptionCode}
          name="type"
          optionData={tableOptionList}
          optionLabelKey="CODE_DESC"
          optionValueKey="CODE_ID"
          handleOnchange={handleFilterChange}
          icon={false}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <StatisticsGraph params={{ ...params }} adexIds={adexIds} />
          <AdExStatisticsGraph params={{ ...params }} adexIds={adexIds} />
          <AdExPrivateStatisticsGraph
            params={{ ...params }}
            adexIds={adexIds}
          />
          <TableContainer
            dataReqPromise={adexStatistics}
            params={{ ...params }}
            sort="desc"
            order="STATS_DTTM"
            dense={true}
            customized={customized}
            hasExcel
            noneSearch
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default Statistics;
